module.exports = __webpack_public_path__ + "static/media/omdenalogo.594bdf9d.jpg";